import styled from 'styled-components/macro'

import { theme, fluidSystem, mediaShort } from 'styled'

export const Root = styled.div`
  ${fluidSystem};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  pointer-events: none;
  z-index: ${({ topLayer }) => (topLayer ? 1 : 0)};

  ${mediaShort`
    padding: 40px;
  `};
`

export const LogoBox = styled.div`
  ${fluidSystem};
  color: ${({ clr }) => theme.colors[clr]};
  transition: color 0.3s;
  pointer-events: all;

  svg {
    width: 100%;
    height: auto;
  }
`
export const ReadyBox = styled.div`
  ${fluidSystem};
  color: ${({ clr }) => theme.colors[clr]};
  transition: color 0.3s;

  svg {
    width: 100%;
    height: auto;
  }
`
